import type { FsCallbackApi } from '@jsonjoy.com/fs-node-utils';

export const fsCallbackApiList: Array<keyof FsCallbackApi> = [
  'access',
  'appendFile',
  'chmod',
  'chown',
  'close',
  'copyFile',
  'cp',
  'createReadStream',
  'createWriteStream',
  'exists',
  'fchmod',
  'fchown',
  'fdatasync',
  'fstat',
  'fsync',
  'ftruncate',
  'futimes',
  'glob',
  'lchmod',
  'lchown',
  'link',
  'lstat',
  'mkdir',
  'mkdtemp',
  'open',
  'openAsBlob',
  'opendir',
  'read',
  'readv',
  'readdir',
  'readFile',
  'readlink',
  'realpath',
  'rename',
  'rm',
  'rmdir',
  'stat',
  'statfs',
  'symlink',
  'truncate',
  'unlink',
  'unwatchFile',
  'utimes',
  'lutimes',
  'watch',
  'watchFile',
  'write',
  'writev',
  'writeFile',
];
